import * as Yup from 'yup';
import { MTA_ADDRESS_CHANGE_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
const ChangeOfMileageSchema = (initialMileage: number) =>
	Yup.object({
		annualMileage: Yup.number()
			.min(0, MTA_ADDRESS_CHANGE_ERRORS.annualMileageGreaterThanZero)
			.required(MTA_ADDRESS_CHANGE_ERRORS.annualMileageRequired)
			.test(
				'annual-mileage-not-decreased',
				() => `You cannot decrease your annual mileage. Please enter a value greater than ${initialMileage}.`,
				function (value) {
					if (value === undefined || value === null) return true;
					return value >= initialMileage;
				},
			),
	});

export default ChangeOfMileageSchema;
